import styled from "@emotion/styled";
import React from "react";
import AgentsCollections from "@components-pages/collection/landing/agents-collections";
import CoverSection from "@components-pages/collection/landing/cover-section";
import FeaturedProperty from "@components-pages/collection/landing/featured-property";
import InfoVideoSection from "@components-pages/collection/landing/info-video-section";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { useRouter } from "next/router";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

import type { GetStaticPropsContext, NextPage } from "next";
import Layout from "@components/layout";
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`lang/${locale}.json`)).default,
    },
  };
}

const Collection: NextPage = (props) => {
  const router = useRouter();
  const metaData: IHeadMetaComponent = {
    title: "collection",
    keyWords: CKeyWordsPages.homeCollections,
    description: "collections",
    url: router.asPath,
    picture: "/images/image-optimize/remax-collection-cover_meta.jpg",
  };

  return (
    <Layout
      showFooter={true}
      backgroundColorFooter="var(--color-brand-cream-primary)"
    >
      <HeadMeta {...metaData} />
      <div style={{ backgroundColor: "var(--color-brand-cream-primary)" }}>
        <CoverSection />
        <ContentCurve>
          <InfoVideoSection />
          <ContainerFeaturedProperty>
            <FeaturedProperty></FeaturedProperty>
          </ContainerFeaturedProperty>
        </ContentCurve>
        <ContainerAgents>
          <AgentsCollections></AgentsCollections>
        </ContainerAgents>
      </div>
    </Layout>
  );
};

export default Collection;

const ContainerFeaturedProperty = styled.div`
  margin: auto;
  width: 100%;
  padding-bottom: 80px;
`;

const ContainerAgents = styled.div`
  margin: auto;
  width: 100%;
  padding-bottom: 80px;
`;

const ContentCurve = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  background: var(--color-brand-blue-collection-main);
  border-radius: 0px 0px 0px 200px;
  @media screen and (max-width: 600px) {
    border-radius: 0px;
  }
`;
